import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import { EditEquipmentValidationFields, EquipmentUtilities } from "../../../EquipmentUtilities";
import Toast from "../../../helpers/Toast";
import { SearchByClientName } from "../../../models/Client/SearchByClientName";
import { EquipmentEditProps } from "../../../models/Equipment/EquipmentProps";
import { UpdateEquipmentDTO } from "../../../models/Equipment/UpdateEquipmentDTO";
import { ClientService } from "../../../services/ClientService";
import { EquipmentService } from "../../../services/EquipmentService";
import { SettingsService } from "../../../services/SettingsService";
import ButtonComponent from "../../ButtonComponent";
import InputComponent from "../../InputComponent";
import ModalComponent from "../../ModalComponent";
import SearchSelectComponent from "../../SearchSelectComponent";
import { SelectItemsProps } from "../../Select2Component";
import useValidationSchema from "../../Validations";
import SearchOrTypeSelectComponent from "../../SearchOrTypeSelectComponent";
import CheckboxComponent from "../../CheckboxComponent";
import { Utilities } from "../../../helpers/Utilities";
import { ClientAddressService } from "../../../services/ClientAddressService";
import { ClientAddressDTO } from "../../../models/ClientAddress/ClientAdressDTO";
import { CountryService } from "../../../services/CountryService";
import ClientAddressPopup from "../EquipementEditAddressPop";

export default function EquipamentEditA({ ...props }: EquipmentEditProps) {
    const { id } = useParams<{ id: string }>();
    const intl = useIntl();
    const equipmentService = new EquipmentService();
    const clientService = new ClientService();
    const settingsService = new SettingsService();
    const clientAddressService = new ClientAddressService();
    const [isEditButtonLoading, setIsEditButtonLoading] = useState<boolean>(false);
    const [isDeleteButtonLoading, setIsDeleteButtonLoading] = useState<boolean>(false);

    const [clientSelected, setClientSelected] = useState<SelectItemsProps | null>(null);
    const [brandSelected, setBrandSelected] = useState<SelectItemsProps | null>(null);
    const [modelSelected, setModelSelected] = useState<SelectItemsProps | null>(null);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const { availableModules } = useAvailableModulesContext(); const [isActiveCarPlate, setIsActiveCarPlate] = useState<boolean>(false);
    const [isActiveSoftwareModule, setIsActiveSoftwareModule] = useState<boolean>(false);
    const [isActiveWarrantySupplier, setIsActiveWarrantySupplier] = useState<boolean>(false);
    const [isActiveWarrantySeller, setIsActiveWarrantySeller] = useState<boolean>(false);
    const [isActiveRecallModule, setIsActiveRecallModule] = useState<boolean>(false);
    const [isActiveLoanEquipmentModule, setIsActiveLoanEquipmentModule] = useState<boolean>(false);
    const [isOwnerClient, setIsOwnerClient] = useState<boolean>(false);
    const [clientAddress, setClientAddress] = useState<ClientAddressDTO | null>(null);
    const countryService = new CountryService();
    const [contryName, setContryName] = useState<string>("");
    const [isPopupVisible, setIsPopupVisible] = useState(false);


    useEffect(() => {
        if (availableModules.includes("IsActiveCarPlate")) {
            setIsActiveCarPlate(true);
        }
        if (availableModules.includes("IsActiveSoftwareModule")) {
            setIsActiveSoftwareModule(true);
        }
        if (availableModules.includes("IsActiveWarrantySeller")) {
            setIsActiveWarrantySeller(true);
        }
        if (availableModules.includes("IsActiveWarrantySupplier")) {
            setIsActiveWarrantySupplier(true);
        }
        if (availableModules.includes("IsActiveRecallModule")) {
            setIsActiveRecallModule(true);
        }
        if (availableModules.includes("IsActiveLoanEquipmentModule")) {
            setIsActiveLoanEquipmentModule(true);
        }
    }, [availableModules]);

    useEffect(() => {
        if (props.equipment) {
            const title = isActiveCarPlate
                ? `Equipamento ${props.equipment.carPlate} || ${props.equipment.serialNumber}`
                : `Equipamento ${props.equipment.serialNumber}`;
            props.setPageTitle(title);
        }
    }, [isActiveCarPlate, props.equipment]);

    const modalConfirmationText =
        isActiveCarPlate
            ? `Tem a certeza que quer remover o equipamento com a placa ${props.equipment?.carPlate} || ${props.equipment?.serialNumber}?`
            : `Tem a certeza que quer remover o equipamento com o número de série ${props.equipment?.serialNumber}?`;

    useEffect(() => {
        if (props.equipment && props.equipment.client) {
            setClientSelected({
                value: props.equipment.client.erpId,
                label: props.equipment.client.name
            });

            if (props.equipment.brand) {
                setBrandSelected({
                    label: props.equipment.brand,
                    value: props.equipment.brand,
                });
            }

            if (props.equipment.model) {
                setModelSelected({
                    label: props.equipment.model,
                    value: props.equipment.model,
                });
            }

            // Check if current client is the owner client
            const checkIfClientIsOwner = async () => {
                const ownerClientResponse = await settingsService.GetByName("ownerClientId");
                if (ownerClientResponse.success && ownerClientResponse.obj) {
                    const ownerClientId = ownerClientResponse.obj.value;
                    setIsOwnerClient(props.equipment?.client?.erpId === ownerClientId);
                }
            };

            checkIfClientIsOwner();
        }
    }, [props.equipment]);
    useEffect(() => {
        (async () => {
            const addressId = Number(props.equipment?.clientAddressId);
            if (!addressId) return;


            const response = await clientAddressService.getById(addressId);

            if (response.success && response.obj) {
                setClientAddress(response.obj);
            } else {
                setClientAddress(null);
            }
        })();
    }, [props.equipment?.clientAddressId]);


    useEffect(() => {
        const fetchCountryName = async () => {
            if (clientAddress?.countryId) {
                const result = await searchCountryById(clientAddress.countryId.toString());
                if (result.length > 0) {
                    setContryName(result[0].label);
                }
            }
        };
        fetchCountryName();
    }, [clientAddress?.countryId]);


    const searchCountryById = async (input: string): Promise<SelectItemsProps[]> => {
        const result = await countryService.GetCountryById(parseInt(input));
        if (!result.success || !result.obj) {
            Toast.Show("error", result.message);
            return [];
        }

        return [{
            value: result.obj.id.toString(),
            label: result.obj.name,
        }];
    };
    const handleOpenPopup = () => {
        setIsPopupVisible(true);
    };

    const handleAddressSelected = (address: ClientAddressDTO) => {
        setClientAddress(address);

    };

    const getClientByName = async (value: string): Promise<SelectItemsProps[]> => {
        var data: SearchByClientName = {
            name: value,
        };
        var response = await clientService.SearchByName(data);
        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            return [];
        }

        const list: SelectItemsProps[] = [];

        response.obj.forEach((element: any) => {
            var item: SelectItemsProps = {
                value: element.erpId,
                label: element.name,
            };
            list.push(item);
        });

        return list;
    };

    const fields = EditEquipmentValidationFields(isActiveCarPlate);
    const schemaClientValidation = useValidationSchema(fields);

    const editEquipment = async () => {
        setIsEditButtonLoading(true);
        const updatedEquipment: UpdateEquipmentDTO = {
            erpId: props.equipment?.erpId ?? null,
            clientErpId: clientSelected?.value! ?? null,
            clientAddressId: clientAddress?.id.toString(),
            name: props.equipment?.name ?? null,
            service: props.equipment?.service ?? null,
            carPlate: props.equipment?.carPlate ?? null,
            carPlateValidation: isActiveCarPlate ?? null,

            serialNumber: props.equipment?.serialNumber ?? null,
            softwareName: props.equipment?.softwareName ?? null,
            softwareVersion: props.equipment?.softwareVersion ?? null,
            brand: brandSelected?.label ?? null,
            model: modelSelected?.label ?? null,
            isLoanEquipment: props.equipment?.isLoanEquipment ?? null,

            warrantySupplierDescription: props.equipment?.warrantySupplierDescription ?? null,
            warrantySupplierStartDate: props.equipment?.warrantySupplierStartDate ?? null,
            warrantySupplierEndDate: props.equipment?.warrantySupplierEndDate ?? null,
            warrantySupplierIncludesParts: props.equipment?.warrantySupplierIncludesParts ?? null,
            warrantySupplierIncludesTravel: props.equipment?.warrantySupplierIncludesTravel ?? null,
            warrantySupplierIncludesWork: props.equipment?.warrantySupplierIncludesWork ?? null,

            warrantySellerDescription: props.equipment?.warrantySellerDescription ?? null,
            warrantySellerStartDate: props.equipment?.warrantySellerStartDate ?? null,
            warrantySellerEndDate: props.equipment?.warrantySellerEndDate ?? null,
            warrantySellerIncludesParts: props.equipment?.warrantySellerIncludesParts ?? null,
            warrantySellerIncludesTravel: props.equipment?.warrantySellerIncludesTravel ?? null,
            warrantySellerIncludesWork: props.equipment?.warrantySellerIncludesWork ?? null,

            recallDescription: props.equipment?.recallDescription ?? null,
            recallStartDate: props.equipment?.recallStartDate ?? null,
            recallEndDate: props.equipment?.recallEndDate ?? null,
            recallIncludesSecurity: props.equipment?.recallIncludesSecurity ?? null,
            recallIncludesRisk: props.equipment?.recallIncludesRisk ?? null,
            recallIncludesDefect: props.equipment?.recallIncludesDefect ?? null,
        };

        const { error } = schemaClientValidation.validate(updatedEquipment);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setIsEditButtonLoading(false);
            return;
        }
        const response = await equipmentService.Edit(updatedEquipment);
        setIsEditButtonLoading(false);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            return;
        }
        Toast.Show("success", response.message);
    };

    const deleteEquipment = async () => {
        setIsDeleteButtonLoading(true);
        const response = await equipmentService.Delete(id);
        setIsDeleteButtonLoading(false);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            return;
        }
        Toast.Show("success", response.message);
    };


    return (
        <>

            <label style={{ margin: "0px", padding: "13px" }}>
                <b>
                    <FormattedMessage id="Screens.EquipmentCreate.SubTitle2" />
                </b>
            </label>
            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <SearchSelectComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    label={intl.formatMessage({
                        id: "Screens.Equipments.Info.Client",
                    })}
                    loadOptions={getClientByName}
                    onChange={(e) => {
                        setClientSelected(e);
                    }}
                    value={clientSelected}
                    style={{ width: "100%" }}
                    isDisabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px" }}>
                <label style={{ margin: "0px", padding: "13px" }}>
                    <b>
                        <FormattedMessage id="Screens.EquipmentCreate.SubTitle" />
                    </b>
                </label>

                <Row
                    style={{
                        margin: "0px",
                        padding: "0px",
                        alignItems: "flex-end",
                        alignContent: "flex-end",
                    }}
                >
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"text"}
                        value={props.equipment?.name}
                        label={intl.formatMessage({
                            id: "Screens.Equipments.Info.Name",
                        })}
                        readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                        onChange={(t: string) => {
                            props.setEquipment({ ...props.equipment!, name: t });
                        }}
                    />
                </Row>

                {isActiveCarPlate && (
                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={props.equipment?.carPlate}
                            label={intl.formatMessage({
                                id: "Screens.Equipments.Info.CarPlate",
                            })}
                            readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                            onChange={(t: string) => {
                                props.setEquipment({ ...props.equipment!, carPlate: t });
                            }}
                        />
                    </Row>
                )}

                <Row style={{
                    marginBottom: "10px",
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end"
                }}>
                    <InputComponent
                        xl={4}
                        lg={4}
                        md={4}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"text"}
                        value={props.equipment?.serialNumber}
                        label={intl.formatMessage({
                            id: "Screens.Equipments.Info.SerialNumber",
                        })}
                        readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                        onChange={(t: string) => {
                            props.setEquipment({ ...props.equipment!, serialNumber: t });
                        }}
                    />

                    <SearchOrTypeSelectComponent
                        xl={3}
                        label={intl.formatMessage({ id: "Screens.Equipments.Info.Brand" })}
                        loadOptions={EquipmentUtilities.SearchBrand}
                        onChange={(e: SelectItemsProps | null) => setBrandSelected(e)}
                        value={brandSelected}
                        isDisabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                    />
                    <SearchOrTypeSelectComponent
                        xl={3}
                        label={intl.formatMessage({ id: "Screens.Equipments.Info.Model" })}
                        loadOptions={EquipmentUtilities.SearchModel}
                        onChange={(e: SelectItemsProps | null) => setModelSelected(e)}
                        value={modelSelected}
                        isDisabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData || !brandSelected}
                    />
                </Row>

                {isOwnerClient && isActiveLoanEquipmentModule && (
                    <Row
                        style={{
                            margin: "0px",
                            marginTop: "10px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={props.equipment?.isLoanEquipment}
                                disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={() => {
                                    props.setEquipment({ ...props.equipment!, isLoanEquipment: !props.equipment?.isLoanEquipment });
                                }}
                                label={intl.formatMessage({ id: "Screens.Equipment.IsLoanEquipment" }, { defaultMessage: "Equipamento para empréstimo" })}
                            />
                        </Col>
                    </Row>
                )}
                {isActiveSoftwareModule &&
                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={props.equipment?.softwareName}
                            label={intl.formatMessage({
                                id: "Screens.Equipments.Info.SoftwareName",
                            })}
                            readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                            onChange={(softwareName: string) => {
                                props.setEquipment({ ...props.equipment!, softwareName: softwareName });
                            }}
                        />

                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={props.equipment?.softwareVersion}
                            label={intl.formatMessage({
                                id: "Screens.Equipments.Info.SoftwareVersion",
                            })}
                            readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                            onChange={(softwareVersion: string) => {
                                props.setEquipment({ ...props.equipment!, softwareVersion: softwareVersion });
                            }}
                        />
                    </Row>
                }

                <Row>
                    <label style={{ margin: "0px", padding: "13px", display: "flex", alignItems: "center" }}>
                        <b style={{ marginRight: "10px" }}>
                            <FormattedMessage id="Screens.EquipmentEdit.EquipmentLocation" />
                        </b>
                        <ButtonComponent
                            text={intl.formatMessage({ id: "Screens.EquipmentEdit.AddAddress" })}
                            onClick={handleOpenPopup}
                            style={{ width: "auto" }}
                        />
                        <ClientAddressPopup
                            visible={isPopupVisible}
                            onClose={() => setIsPopupVisible(false)}
                            equipment={props.equipment!}
                            onSelectAddress={handleAddressSelected}
                        />
                    </label>

                    <Row style={{ margin: "0px", padding: "0px" }}>
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={clientAddress?.street1 || ""}
                            label={intl.formatMessage({
                                id: "Screens.Client.Info.Street",
                            })}
                            readOnly={true}
                        />
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={clientAddress?.street2 || ""}
                            label={intl.formatMessage({
                                id: "Screens.Client.Info.Street2",
                            })}
                            readOnly={true}
                        />
                    </Row>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={clientAddress?.city || ""}
                            label={intl.formatMessage({
                                id: "Screens.Client.Info.City",
                            })}
                            readOnly={true}
                        />
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 inputContainer">
                            <span className="label">
                                {intl.formatMessage({
                                    id: "Screens.Client.Info.NameCountry",
                                })}
                                :
                            </span>
                            <input
                                className="input"
                                type="text"
                                value={contryName || ""}
                                readOnly
                            />
                            {/*Este input serve apenas para visualizar o nome do pais e nao tem fun o de edicao*/}
                        </div>
                    </Row>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={clientAddress?.postalCode || ""}
                            label={intl.formatMessage({
                                id: "Screens.Client.Info.PostalCode",
                            })}
                            readOnly={true}
                        />

                    </Row>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        <InputComponent
                            xl={6}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={props.equipment?.service || ""}
                            label={intl.formatMessage({
                                id: "Screens.Client.Info.Service",
                            })}
                            onChange={(newService: string) => {
                                props.setEquipment({ ...props.equipment!, service: newService });
                            }}
                        />
                    </Row>


                </Row>

                {isActiveWarrantySupplier && (
                    <>
                        <label style={{ margin: "0px", padding: "13px" }}>
                            <b>
                                <FormattedMessage id="Screens.EquipmentCreate.WarrantySupplierSection" />
                            </b>
                        </label>

                        <Row
                            style={{
                                margin: "0px",
                                padding: "0px",
                                alignItems: "flex-end",
                                alignContent: "flex-end",
                            }}
                        >
                            <InputComponent
                                xl={3}
                                lg={3}
                                md={3}
                                sm={3}
                                xs={12}
                                style={{ width: "100%" }}
                                type="date"
                                value={props.equipment?.warrantySupplierStartDate}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierStartDate" })}
                                readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={(warrantySupplierStartDate: Date) => {
                                    props.setEquipment({ ...props.equipment!, warrantySupplierStartDate });
                                }}
                            />

                            <InputComponent
                                xl={3}
                                lg={3}
                                md={3}
                                sm={3}
                                xs={12}
                                style={{ width: "100%" }}
                                type="date"
                                value={props.equipment?.warrantySupplierEndDate}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierEndDate" })}
                                readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={(warrantySupplierEndDate: Date) => {
                                    props.setEquipment({ ...props.equipment!, warrantySupplierEndDate });
                                }}
                            />
                        </Row>

                        <Row
                            style={{
                                margin: "0px",
                                marginTop: "10px",
                                padding: "0px",
                                alignItems: "flex-end",
                                alignContent: "flex-end",
                            }}
                        >
                            <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                                <CheckboxComponent
                                    checked={props.equipment?.warrantySupplierIncludesParts}
                                    disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                    onChange={() => {
                                        props.setEquipment({ ...props.equipment!, warrantySupplierIncludesParts: !props.equipment?.warrantySupplierIncludesParts });
                                    }}
                                    label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierIncludesParts" })}
                                />
                            </Col>

                            <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                                <CheckboxComponent
                                    checked={props.equipment?.warrantySupplierIncludesTravel}
                                    disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                    onChange={() => {
                                        props.setEquipment({ ...props.equipment!, warrantySupplierIncludesTravel: !props.equipment?.warrantySupplierIncludesTravel });
                                    }}
                                    label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierIncludesTravel" })}
                                />
                            </Col>

                            <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                                <CheckboxComponent
                                    checked={props.equipment?.warrantySupplierIncludesWork}
                                    disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                    onChange={() => {
                                        props.setEquipment({ ...props.equipment!, warrantySupplierIncludesWork: !props.equipment?.warrantySupplierIncludesWork });
                                    }}
                                    label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierIncludesWork" })}
                                />
                            </Col>
                        </Row>

                        <Row
                            style={{
                                margin: "0px",
                                padding: "0px",
                                alignItems: "flex-end",
                                alignContent: "flex-end",
                            }}
                        >
                            <InputComponent
                                xl={9}
                                lg={9}
                                md={9}
                                sm={9}
                                xs={12}
                                style={{ width: "100%" }}
                                type="textArea"
                                value={props.equipment?.warrantySupplierDescription}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierDescription" })}
                                readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={(warrantySupplierDescription: string) => {
                                    props.setEquipment({ ...props.equipment!, warrantySupplierDescription });
                                }}
                            />
                        </Row>

                    </>
                )}


                {isActiveWarrantySeller && (
                    <>
                        <label style={{ margin: "0px", padding: "13px" }}>
                            <b>
                                <FormattedMessage id="Screens.EquipmentCreate.WarrantySellerSection" />
                            </b>
                        </label>

                        <Row
                            style={{
                                margin: "0px",
                                padding: "0px",
                                alignItems: "flex-end",
                                alignContent: "flex-end",
                            }}
                        >
                            <InputComponent
                                xl={3}
                                lg={3}
                                md={3}
                                sm={3}
                                xs={12}
                                style={{ width: "100%" }}
                                type="date"
                                value={props.equipment?.warrantySellerStartDate}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerStartDate" })}
                                readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={(warrantySellerStartDate: Date) => {
                                    props.setEquipment({ ...props.equipment!, warrantySellerStartDate });
                                }}
                            />

                            <InputComponent
                                xl={3}
                                lg={3}
                                md={3}
                                sm={3}
                                xs={12}
                                style={{ width: "100%" }}
                                type="date"
                                value={props.equipment?.warrantySellerEndDate}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerEndDate" })}
                                readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={(warrantySellerEndDate: Date) => {
                                    props.setEquipment({ ...props.equipment!, warrantySellerEndDate });
                                }}
                            />
                        </Row>

                        <Row
                            style={{
                                margin: "0px",
                                marginTop: "10px",
                                padding: "0px",
                                alignItems: "flex-end",
                                alignContent: "flex-end",
                            }}
                        >
                            <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                                <CheckboxComponent
                                    checked={props.equipment?.warrantySellerIncludesParts}
                                    disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                    onChange={() => {
                                        props.setEquipment({ ...props.equipment!, warrantySellerIncludesParts: !props.equipment?.warrantySellerIncludesParts });
                                    }}
                                    label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerIncludesParts" })}
                                />
                            </Col>

                            <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                                <CheckboxComponent
                                    checked={props.equipment?.warrantySellerIncludesTravel}
                                    disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                    onChange={() => {
                                        props.setEquipment({ ...props.equipment!, warrantySellerIncludesTravel: !props.equipment?.warrantySellerIncludesTravel });
                                    }}
                                    label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerIncludesTravel" })}
                                />
                            </Col>

                            <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                                <CheckboxComponent
                                    checked={props.equipment?.warrantySellerIncludesWork}
                                    disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                    onChange={() => {
                                        props.setEquipment({ ...props.equipment!, warrantySellerIncludesWork: !props.equipment?.warrantySellerIncludesWork });
                                    }}
                                    label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerIncludesWork" })}
                                />
                            </Col>
                        </Row>

                        <Row
                            style={{
                                margin: "0px",
                                padding: "0px",
                                alignItems: "flex-end",
                                alignContent: "flex-end",
                            }}
                        >

                            <InputComponent
                                xl={9}
                                lg={9}
                                md={9}
                                sm={9}
                                xs={12}
                                style={{ width: "100%" }}
                                type="textArea"
                                value={props.equipment?.warrantySellerDescription}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerDescription" })}
                                readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={(warrantySellerDescription: string) => {
                                    props.setEquipment({ ...props.equipment!, warrantySellerDescription });
                                }}
                            />
                        </Row>
                    </>
                )}
            </Row >

            {isActiveRecallModule && (
                <>
                    <label style={{ margin: "0px", padding: "13px" }}>
                        <b>
                            <FormattedMessage id="Screens.EquipmentCreate.RecallSection" />
                        </b>
                    </label>

                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <InputComponent
                            xl={3}
                            lg={3}
                            md={3}
                            sm={3}
                            xs={12}
                            style={{ width: "100%" }}
                            type="date"
                            value={props.equipment?.recallStartDate}
                            label={intl.formatMessage({ id: "Screens.Equipment.RecallStartDate" })}
                            readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                            onChange={(recallStartDate: Date) => {
                                props.setEquipment({ ...props.equipment!, recallStartDate: recallStartDate });
                            }}
                        />

                        <InputComponent
                            xl={3}
                            lg={3}
                            md={3}
                            sm={3}
                            xs={12}
                            style={{ width: "100%" }}
                            type="date"
                            value={props.equipment?.recallEndDate}
                            label={intl.formatMessage({ id: "Screens.Equipment.RecallEndDate" })}
                            readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                            onChange={(recallEndDate: Date) => {
                                props.setEquipment({ ...props.equipment!, recallEndDate: recallEndDate });
                            }}
                        />
                    </Row>

                    <Row
                        style={{
                            margin: "0px",
                            marginTop: "10px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={props.equipment?.recallIncludesSecurity}
                                disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={() => {
                                    props.setEquipment({ ...props.equipment!, recallIncludesSecurity: !props.equipment?.recallIncludesSecurity });
                                }}
                                label={intl.formatMessage({ id: "Screens.Equipment.RecallIncludesSecurity" })}
                            />
                        </Col>

                        <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={props.equipment?.recallIncludesRisk}
                                disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={() => {
                                    props.setEquipment({ ...props.equipment!, recallIncludesRisk: !props.equipment?.recallIncludesRisk });
                                }}
                                label={intl.formatMessage({ id: "Screens.Equipment.RecallIncludesRisk" })}
                            />
                        </Col>

                        <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={props.equipment?.recallIncludesDefect}
                                disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                                onChange={() => {
                                    props.setEquipment({ ...props.equipment!, recallIncludesDefect: !props.equipment?.recallIncludesDefect });
                                }}
                                label={intl.formatMessage({ id: "Screens.Equipment.RecallIncludesDefect" })}
                            />
                        </Col>
                    </Row>

                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >

                        <InputComponent
                            xl={9}
                            lg={9}
                            md={9}
                            sm={9}
                            xs={12}
                            style={{ width: "100%" }}
                            type="textArea"
                            value={props.equipment?.recallDescription}
                            label={intl.formatMessage({ id: "Screens.Equipment.RecallDescription" })}
                            readOnly={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                            onChange={(recallDescription: string) => {
                                props.setEquipment({ ...props.equipment!, recallDescription });
                            }}
                        />
                    </Row>
                </>
            )}

            <Row style={{ marginTop: "10px", paddingLeft: "13px", paddingBottom: "13px", paddingRight: "13px" }}>
                <Col xl={2} lg={6} md={6} sm={6} xs={6}>
                    <ButtonComponent
                        disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                        loading={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                        text={intl.formatMessage({ id: "EquipmentEditA.Save" })}
                        onClick={editEquipment}
                        style={{ width: "100%" }}
                    />
                </Col>
                <Col xl={2} lg={6} md={6} sm={6} xs={6}>
                    <ButtonComponent
                        disabled={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                        loading={isEditButtonLoading || isDeleteButtonLoading || props.isFetchingEquipmentData}
                        text={intl.formatMessage({ id: "EquipmentEditA.Remove" })}
                        onClick={() => {
                            setIsOpen(true);
                        }}
                        style={{ width: "100%" }}
                    />
                </Col>
            </Row>

            <ModalComponent
                IsOpen={isOpen}
                text={modalConfirmationText}
                OnClickRight={() => setIsOpen(false)}
                OnClickLeft={() => {
                    setIsOpen(false);
                    deleteEquipment();
                }}
                title={"Remover Equipamento"}
                buttonRight={"Não"}
                buttonLeft={"Sim"}
            />
        </>
    );
}
